export default "# Scene\n\n## SceneAssetLibrary\n\n::demo{name=sceneAssetLibrary}"